const NavBarHeading = () => {
    return (
        <p className="paragraph">
            Every new Qoonity application comes with default modules for
            Reporting, User Management, etc. To enable you perform live testing,
            Qoonity deploys the Front End for your application based on your
            Specifications (if you provide the specifications. Your application
            will be deployed into Qoonity environment except you provide your
            AWS or Azure account/subscription credentials).
        </p>
    )

}
export default NavBarHeading;